/* global angular swal _*/
import './style.less';
import states from './states.js';
import { defaultSponsorStatements } from '@prolaera/library';
import tourText from './tourText';

export default function($log, $q, $stateParams, $state, $transitions, Swal, Upload, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;

  // Onboarding Top
  $transitions.onExit({ exiting: 'app.admin.sponsors.sponsor' }, () => {
    if (vm.tour) vm.tour.end();
  });

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.tourReady = tour => (vm.tour = tour);
  vm.startTour = init => {
    if (!init || (init && $stateParams.tour === 'start')) vm.tour.start();
  };
  // Onboarding Bottom

  vm.tourText = tourText;
  vm.states = states;
  vm.uploadingS3 = false;
  vm.formData = {};
  vm.$onInit = activate;
  vm.sponsorStatement = defaultSponsorStatements.sponsorStatement;

  vm.submit = (sponsor, update = false, redirect = true) => {
    if (sponsor.signatureUrl && !sponsor.signature.imageUrl) {
      sponsor.signature.imageUrl = sponsor.signatureUrl;
    }

    if (!update && (!sponsor || (!vm.logo && !sponsor.logoUrl) || (!vm.signature && !sponsor.signature.imageUrl))) {
      return swal('Please include all required information');
    }

    clean(sponsor);

    return ApiClass.companiesIdTypeTypeIdPatch(
      { manage: true, id: company_id, type_id: $stateParams.sponsor_id, type: 'sponsors' },
      sponsor
    )
      .then(() => {
        if (update) Swal.toast('Sponsor information updated');
        if (!update) Swal.toast('Sponsor published');
        if (redirect) $state.go('app.admin.sponsors', { id: $stateParams.id });
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.publish = sponsor => {
    sponsor.active = true;
    return vm.submit(sponsor);
  };

  function uploadFile(file, s3Policy) {
    return $q((resolve, reject) => {
      return Upload.upload({
        url: s3Policy.filePolicy.action,
        data: s3Policy.filePolicy.fields,
        file: file,
        method: 'POST',
        skipAuthorization: true
      })
        .then(
          () => resolve(s3Policy),
          resp => {
            $log.error('Error status: ' + resp.status);
            reject(resp);
            throw new Error(`PDF UPLOADING ERROR ${$stateParams.id}`);
          },
          evt => $log.debug(evt)
        )
        .catch(error => reject(error));
    });
  }

  vm.s3FileUpload = (file, type) => {
    if (!file) return;
    vm[`${type}Button`] = true;

    ApiClass.companiesIdTypePut(
      {
        manage: true,
        id: ProfileClass.company_id,
        type: 'policies'
      },
      {
        policy: 'sponsor',
        sponsor_id: $stateParams.sponsor_id,
        file_type: file.type,
        file_name: file.name
      }
    )
      .then(({ data: { item: s3Policy } }) => uploadFile(file, s3Policy))
      .then(s3Policy => {
        vm.formData.sponsor_id = s3Policy.sponsor_id;
        vm.formData[`${type}Url`] = s3Policy.link;
        vm.formData[`${type}Name`] = file.name;
        vm.uploaded = true;

        if (type === 'signature' && vm.formData.signature) vm.formData.signature.imageUrl = s3Policy.link;

        clean(vm.formData);

        return vm.submit(vm.formData, true, false);
      })
      .then(() => {
        delete vm[`${type}File`];
        vm[`${type}Button`] = false;
      })
      .catch(error => {
        vm[`${type}Button`] = false;
        $log.error(error);
        throw error;
      });
  };

  function clean(obj) {
    Object.keys(obj).forEach(propName => {
      if (obj[propName] === '' || obj[propName] === null) return delete obj[propName];
      if (typeof obj[propName] === 'object') return clean(obj[propName]);
    });
  }

  function activate() {
    if (!$stateParams.sponsor_id) return $state.go('app.admin.sponsors');

    ApiClass.companiesIdTypeTypeIdGet(
      { manage: true, id: company_id, type_id: $stateParams.sponsor_id, type: 'sponsors' },
      null
    )
      .then(function({ data: { item: sponsor } }) {
        $log.debug(arguments);
        vm.formData = sponsor;

        if (!vm.formData.sponsors || _.isArray(vm.formData.sponsors)) {
          vm.formData.sponsors = {};
        }

        if (!vm.formData.sponsorStatement) {
          vm.formData.sponsorStatement = defaultSponsorStatements.sponsorStatement;
        }

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/sponsors/edit/index.js